import React from 'react'

import MenuSection from '../MenuSection'

import { COMPLETED_OPTIONS, VIEW_OPEN } from '../../helpers/parse'
import { useTaskFilters } from '@SonarCX/providers/TaskFiltersProvider'

type CompletedStatusFilterProps = {
  checkFilters?: boolean
  menuMode?: boolean
  closeModal?: () => void
}

const CompletedStatusFilter: React.FC<CompletedStatusFilterProps> = props => {
  const { state, handleChange } = useTaskFilters()

  return (
    <MenuSection
      title='Completed Statuses'
      options={COMPLETED_OPTIONS}
      value={state.completeValue}
      setValue={handleChange('completeValue')}
      hideNullOption
      nullOpt={VIEW_OPEN}
      {...props}
    />
  )
}

export default CompletedStatusFilter
